import { render, staticRenderFns } from "./calc-params.vue?vue&type=template&id=049e3088&scoped=true"
import script from "./calc-params.vue?vue&type=script&lang=ts"
export * from "./calc-params.vue?vue&type=script&lang=ts"
import style0 from "./calc-params.vue?vue&type=style&index=0&id=049e3088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e3088",
  null
  
)

export default component.exports